<template>
  <div id="vessel-controller" :style="warpstyle">
    <vs-row class="vc-center">
      <vs-button
        v-if="!playing"
        class="vc-btn"
        color="primary"
        type="relief"
        icon="play_arrow"
        @click="onPlay"
      ></vs-button>
      <vs-button v-else class="vc-btn" color="primary" type="relief" icon="pause" @click="onPause"></vs-button>
      <vs-button class="vc-btn" color="danger" type="relief" icon="stop" @click="onStop"></vs-button>
      <div class="vc-slider">
        <vs-slider v-model="value" :max="max" color="dark" @change="onChange" />
      </div>
    </vs-row>
  </div>
</template>
<script>
export default {
  name: "VesselController",
  props: {
    max: {
      type: Number,
      default: 100
    },
    onChangeValue: {
      type: Function,
      default() {}
    },
    warpstyle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      value: 0,
      playing: false,
      tickerTimer: undefined
    };
  },
  destroyed() {
    this.value = 0;
    this.clearTickerTimer(true);
  },
  methods: {
    onChange(value) {
      this.onChangeValue(value);
    },
    onPlay() {
      if (!this.tickerTimer) {
        if (this.value >= this.max - 1) {
          this.value = 0;
        }
        this.playing = true;
        this.onTickerTimer();
      }
    },
    onStop() {
      this.value = 0;
      this.clearTickerTimer(true);
    },
    onPause() {
      this.clearTickerTimer(false);
    },
    clearTickerTimer(isStop) {
      if (this.tickerTimer) {
        clearTimeout(this.tickerTimer);
        this.tickerTimer = null;
        this.playing = false;
        if (isStop) {
          this.value = 0;
        }
      }
    },
    onTickerTimer() {
      const vm = this;
      this.tickerTimer = setTimeout(() => {
        vm.onTickerTimer();
        if (vm.value + 1 <= this.max) {
          vm.value += 1;
        } else if (vm.value + 1 >= this.max) {
          vm.clearTickerTimer(false);
        }
      }, 1000);
    }
  }
};
</script>
<style scoped>
#vessel-controller {
  justify-content: center;
  z-index: 99999;
  width: 400px;
  height: auto;
  background-color: white;
  margin: 5% auto;
  max-width: 400px;
}
.vc-center {
  justify-content: center;
}
.vc-btn {
  margin: 4px;
}
.vc-slider {
  padding: 8px;
  width: 200px;
  margin-right: 16px;
}
.vc-txt {
  margin: 8px;
}
.con-vs-slider {
  min-width: 200px;
}
</style>